module.exports = __webpack_public_path__ + "static/media/iconExercices.adb127a8.svg";